jQuery(document).ready(function($) {

    // --- SİDEBAR AÇMA FONKSİYONU ---
    window.openSidebar = function(targetId) {
        var $wrap = $('#' + targetId);
        var $panel = $('#' + targetId + '-panel');

        if (!$wrap.length) return; // Sidebar sayfada yoksa işlem yapma

        $wrap.removeClass('hidden');
        
        // CSS transition için küçük bir gecikme
        setTimeout(function() { 
            $panel.css('transform', 'translateX(0)'); 
        }, 10);
        
        $('body').css('overflow', 'hidden');
    };

    // --- SİDEBAR KAPATMA FONKSİYONU ---
    window.closeSidebar = function(targetId) {
        var $wrap = $('#' + targetId);
        var $panel = $('#' + targetId + '-panel');

        if (!$wrap.length) return;

        // PHP'den elementin data niteliğine yazdırdığımız "kapanma yönünü" alıyoruz
        var hiddenTransform = $panel.data('hidden-transform') || 'translateX(100%)';

        $panel.css('transform', hiddenTransform);
        $('body').css('overflow', '');
        
        // Animasyon bittikten sonra wrapper'ı gizle
        setTimeout(function() { 
            $wrap.addClass('hidden'); 
        }, 300);
    };

    // --- EVENT DİNLEYİCİLER (Global) ---

    // 1. Çarpı butonuna tıklayınca kapatma
    $(document).on('click', '[data-close-sidebar]', function() {
        var targetId = $(this).data('close-sidebar');
        closeSidebar(targetId);
    });

    // 2. Koyu arka plana (overlay) tıklayınca kapatma
    $(document).on('click', '.js-sidebar-overlay', function() {
        var targetId = $(this).data('target');
        closeSidebar(targetId);
    });

    // 3. ESC tuşuna basınca açık olan tüm sidebarları kapatma
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $('.js-sidebar-wrap:not(.hidden)').each(function() {
                var targetId = $(this).attr('id');
                closeSidebar(targetId);
            });
        }
    });

});